import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import classNames from 'classnames';
import {useSelector, shallowEqual} from 'react-redux';
import lodash from "lodash";

import {detectIconById} from '../../../../common/enum';

import Loading from '../../../../components/loading';
import {getDetailSearch} from '../../../../actions/detail-search';
import buildSearch from '../main-search/buildSearch';
import './styles.scss';


import {CSVLink} from "react-csv";

function SearchAdvanced(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const dataSearch = useSelector(state => state.detailSearch, shallowEqual);

    const [loading, setLoading] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [listCSV, setListCSV] = useState([]);
    const [searchAdvance, setSearchAdvance] = useState({
        columns: {
            groups: [],
            values: [],
            keys: '',
        },
        data: [],
        one_conditions: [],
    });

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (searchAdvance.data.length > 0){
            buildCsv()
        }
    }, [searchAdvance, selectedIndex])
    const fetchData = async () => {
        setLoading(true);
        const raw = buildSearch(dataSearch);
        try {
            const response = await dispatch(getDetailSearch(raw, dataSearch.type));
            setLoading(false);
            setSearchAdvance(response);
        } catch (e) {
            setLoading(false);
        }
    };
    const buildCsv = () => {
        const arr = [
            ['テーブルに表示していない選択中の条件'], dataOneCondition ? dataOneCondition : [],
            headerData
        ];
        const content = dataCSV;
        content.forEach(value => {
            const raw = lodash.clone(value.item || []);
            arr.push(lodash.map(lodash.filter(raw, val => val.text), 'text'));
        });
        setListCSV(arr)
    }
    const dataCSV = useMemo(() => {
        if (searchAdvance.data[selectedIndex]) {
            const arr = searchAdvance.data[selectedIndex]['rows'].map((value, index) => {
                const itemArr = searchAdvance.data[selectedIndex]['rows'].length > 0 && searchAdvance.data[selectedIndex]['rows'][0].oppnent_team ? [{text: (value.oppnent_player) ? value.oppnent_player.name : value.oppnent_team.name}] : [];
                searchAdvance.columns.groups.map(group => {
                    itemArr.push({text: value.groups[group.column]});
                })
                searchAdvance.columns.values.map(val => {
                    itemArr.push({text: value.values[val.column]});
                })
                return {
                    key: index,
                    table: 1,
                    item: itemArr
                }
            });
            return arr;
        }
    }, [searchAdvance, selectedIndex])
    const dataOneCondition = useMemo(() => {
        if(searchAdvance.one_conditions.length > 0){
            const arr = [];
            searchAdvance.one_conditions.map((item) => {
                arr.push(item.name + '／' + item.selected.name);
            });
            return arr;
        }
    },[[searchAdvance]])
    const headerData = useMemo(() => {
        const arr = searchAdvance.data.length > 0 && searchAdvance.data[selectedIndex]['rows'].length > 0 && searchAdvance.data[selectedIndex]['rows'][0].oppnent_team ? ['対戦相手'] : [];
        searchAdvance.columns.groups.length > 0 && searchAdvance.columns.groups.map(item => {
            arr.push(item.name);
        })
        searchAdvance.columns.values.length > 0 && searchAdvance.columns.values.map(item => {
            arr.push(item.name);
        })
        return arr;
    }, [searchAdvance.columns])

    return <div className="search-result">
        <div className="search-result-title">
            <h2>詳細検索</h2>
            <CSVLink className={'csv-download'}
                     data={listCSV}
                     filename={'detail_search.csv'}>
                CSVダウンロード
            </CSVLink>
        </div>
        <div className='notice-result'>
            <div>
                <div>
                    テーブルに表示していない選択中の条件
                </div>
                <div style={{'margin-top': '15px', 'overflow-wrap': 'anywhere'}}>
                    {searchAdvance.one_conditions.length > 0 ? searchAdvance.one_conditions.reduce((acc, item, idx) => {
                        return acc + ((idx > 0) ? '、' : '') + item.name + '／' + item.selected.name;
                    }, '') : '-'}
                </div>
            </div>
            <button onClick={() => history.push('/detailed-search')}>再検索</button>
        </div>

        <div className='content-result-search'>
            <div className='menu-result' style={{marginBottom: 15}}>
                <ul>
                    {searchAdvance.data.map((item, index) => <li key={index} onClick={() => setSelectedIndex(index)}
                                                                 className={classNames(index === selectedIndex && 'active')}>
                        <img alt='logo' src={detectIconById(item.team && item.team.id)}/>
                        <span>{(item.player) ? item.player.name : item.team.name}</span>
                    </li>)}
                </ul>
            </div>

            <div className='table-app-search'>
                <table>
                    <thead>
                    <tr>
                        {(() => {
                            if (searchAdvance.data.length > 0 && searchAdvance.data[selectedIndex].rows.length > 0 && searchAdvance.data[selectedIndex].rows[0].oppnent_team) {
                                return <th>対戦相手</th>
                            }
                        })()}

                        {searchAdvance.columns.groups.map((item) => <th key={item.column}>
                            {item.name}
                        </th>)}
                        {searchAdvance.columns.values.map((item) => <th key={item.column}>
                            {item.name}
                        </th>)}
                    </tr>
                    </thead>
                    <tbody>
                    {
                        searchAdvance.data.length > 0 && searchAdvance.data[selectedIndex].rows.map((item, index) => <tr
                            key={index}>
                            {(() => {
                                if (item.oppnent_team) {
                                    return <td>{(item.oppnent_player) ? item.oppnent_player.name : item.oppnent_team.name}</td>
                                }
                            })()}
                            {searchAdvance.columns.groups.map((group, idx) => <td key={'group' + idx}>
                                {item.groups[group.column]}
                            </td>)}
                            {searchAdvance.columns.values.map((value, idx) => <td key={'group' + idx}>
                                {item.values[value.column]}
                            </td>)}
                        </tr>)
                    }
                    </tbody>
                </table>
            </div>
        </div>
        <Loading show={loading}/>
    </div>
}

export default SearchAdvanced;